import OrderDetailsPage from "./ui/OrderDetailsPage";

export default OrderDetailsPage;
